import React, { lazy, Suspense } from 'react';

const LazyContactView = lazy(() => import('./ContactView'));

const ContactView = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyContactView {...props} />
  </Suspense>
);

export default ContactView;
